import { useAuthStore } from '../stores/authStore'
import { Button } from '../components/ui'

export default function Login() {
  const { login, isLoading, error } = useAuthStore()

  return (
    <div className="min-h-screen bg-bg-page flex items-center justify-center p-6">
      <div className="card max-w-md w-full">
        <div className="text-center mb-8">
          <img 
            src="/PraxisCRM.png" 
            alt="" 
            className="h-16 w-16 mx-auto mb-4"
          />
          <h1 className="font-semibold text-2xl text-text-primary mb-2">
            Praxis<span className="text-action-primary">CRM</span>
          </h1>
          <p className="text-sm text-text-secondary">
            We can't see your data. We can't sell your data. That's the point.
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-[#F5F5F3] rounded-lg p-4">
            <h2 className="text-sm font-semibold text-text-primary mb-2">
              Built to make spying impossible
            </h2>
            <ul className="text-sm text-text-secondary space-y-1">
              <li>No database. Your data lives in YOUR Google Drive.</li>
              <li>No tracking. No analytics. No telemetry. Nothing.</li>
              <li>Free forever. No "premium tiers". No bait and switch.</li>
            </ul>
          </div>

          <div className="space-y-4">
            <p className="text-sm text-text-secondary">
              We use the restricted{' '}
              <code className="bg-[#F5F5F3] px-1.5 py-0.5 rounded text-xs">drive.file</code> scope.
              We can only touch files we create. Your documents stay yours.
            </p>

            <Button
              onClick={login}
              disabled={isLoading}
              variant="primary"
              className="w-full"
            >
              {isLoading ? 'Connecting...' : 'Connect Google Drive'}
            </Button>

            {error && (
              <div className="message-error">
                {error}
              </div>
            )}
          </div>

          <p className="text-xs text-text-secondary text-center">
            v1.0.0 // Free and open source // For people who work for themselves
          </p>
        </div>
      </div>
    </div>
  )
}
